import { secondsToHms } from "@audacia-hq/shared/utils";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Transition } from "@headlessui/react";
import { useRouter } from "next/navigation";
import * as React from "react";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import { Expert } from "../../../models/expert";
import { ConsultationType } from "../../../models/global";
import Button from "../../Button";
import DirectCallPhones from "../../experts/DirectCallPhones";

interface Props {
  channel: ConsultationType;
  remainingTime: number;
  writtenMinuteCost: number;
  className?: string;
  expert?: Expert;
}
const CreditTopUpForm: React.FC<Props> = ({
  channel, remainingTime, writtenMinuteCost, className, expert,
}) => {
  const { t } = useTranslation("consultations");
  const router = useRouter();
  const [showDirectNumbers, setShowDirectNumbers] = useState<boolean>(false);

  const remaining = secondsToHms(remainingTime || 0);

  return (
    <>
      <div className={`flex flex-col text-sm p-6 bg-slate-100 rounded-sm gap-3 ${className}`}>
        <div className="text-lg font-semibold py-2 text-center">{t("consultationForm.creditNotice.noCredit.title")}</div>
        <div className="flex flex-col gap-4 text-center">
          {channel === "WRITTEN" && (
            <div>
              <Trans
                i18nKey="consultationForm.creditNotice.remainingTime"
                ns="consultations"
                components={[
                  <span
                    className="font-semibold"
                    dangerouslySetInnerHTML={{ __html: remaining.toTimeString(t) }}
                  />,
                ]}
              />
            </div>
          )}
          <div>
            {channel === "WRITTEN"
              ? (
                <Trans
                  i18nKey="consultationForm.creditNotice.noCredit.written"
                  ns="consultations"
                  values={{
                    minuteCost: writtenMinuteCost,
                  }}
                  components={[
                    <span className="font-semibold" />,
                  ]}
                />
              ) : (
                t("consultationForm.creditNotice.noCredit.live")
              )}
          </div>
        </div>
      </div>

      <div className="py-8 text-center">
        <Button
          size="large"
          render="primary"
          onClick={() => {
            router.push("/packs");
          }}
        >
          <span>{t("consultationForm.creditNotice.topUp")}</span>
        </Button>
      </div>
      {(channel === "PHONE" && expert?.expertCode) && (
        <div>
          <div className="text-center font-bold mt-12 mb-6">
            <button type="button" className="font-bold" onClick={() => setShowDirectNumbers((prev) => !prev)}>
              <span className="mr-2">
                <FontAwesomeIcon
                  icon={faAngleRight}
                  className={`ml-1 transform transition duration-200 ease-in-out ${showDirectNumbers ? "rotate-90" : ""}`}
                />
              </span>
              {t("consultationForm.phone.youCall")}
            </button>
          </div>

          <Transition
            show={showDirectNumbers}
            enter="transition ease-out duration-200"
            enterFrom="transform opacity-0 -translate-y-2"
            enterTo="transform opacity-200 translate-y-0"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-200 translate-y-0"
            leaveTo="transform opacity-0 -translate-y-2"
          >
            <DirectCallPhones expert={expert} />
          </Transition>
        </div>
      )}
    </>
  );
};

export default CreditTopUpForm;
